import { cn } from '@/lib/utils';

interface RichTextDisplayProps {
  content: string;
  className?: string;
}

export function RichTextDisplay({ content, className }: RichTextDisplayProps) {
  return (
    <div
      className={cn(
        'tiptap',
        'prose prose-sm max-w-none',
        'prose-headings:font-semibold prose-headings:text-foreground',
        'prose-h1:text-3xl prose-h1:font-bold',
        'prose-h2:text-2xl prose-h2:font-semibold',
        'prose-h3:text-xl prose-h3:font-semibold',
        'prose-p:text-foreground prose-p:leading-relaxed',
        'prose-strong:text-foreground prose-strong:font-semibold',
        'prose-ul:text-foreground prose-ol:text-foreground',
        'prose-li:text-foreground',
        'prose-blockquote:text-muted-foreground prose-blockquote:border-l-primary',
        'prose-code:bg-muted prose-code:text-foreground prose-code:px-1 prose-code:py-0.5 prose-code:rounded',
        'prose-table:border-collapse',
        'prose-th:border prose-th:border-border prose-th:bg-muted prose-th:p-2 prose-th:text-left',
        'prose-td:border prose-td:border-border prose-td:p-2',
        className
      )}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}
